import dayjs from 'dayjs';

const LEGAL_AGE = 18;

const isLegalAge = (value, age = LEGAL_AGE) =>
  dayjs().diff(dayjs(value), 'y') >= age;

export default isLegalAge;
